// extracted by mini-css-extract-plugin
export default {"crumb":"AppBreadcrumbs_crumb__WCBf6","crumbLabel":"AppBreadcrumbs_crumbLabel__HUeDg","selectedCrumbLabel":"AppBreadcrumbs_selectedCrumbLabel__fp2+J"};